import { render, staticRenderFns } from "./assignCheckExp.vue?vue&type=template&id=506bab36"
import script from "./assignCheckExp.vue?vue&type=script&lang=js"
export * from "./assignCheckExp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports